import React, {useContext, useState} from 'react';
import LoginView from './LoginView';
import {useNavigate} from 'react-router-dom';
import {MadricContext} from '../../Context/MadricContext';
import {login, onedrive} from '../../services/MadricService';
import Spinner from '../Spinner/Spinner';

/**
 * Le login
 * @return {JSX}
 */
function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const {setConnUser} = useContext(MadricContext);

  /**
   * Envoie le formulaire
   * @param {*} event event
   */
  async function handleSubmit(event) {
    let user = {};
    let errorsForm = {};

    if (email === '') {
      errorsForm.email = 'Le email est requis';
    };

    if (password === '') {
      errorsForm.password = 'Le mot de passe est requis';
    };

    if (Object.keys(errorsForm).length > 0) {
      setErrors(errorsForm);
    } else {
      errorsForm = {};
      setErrors(errorsForm);
      setIsLoading(true);
      const res = await login(email, password);
      setIsLoading(false);

      if (res === 'Invalid credentials') {
        errorsForm.invalid = 'Le mot de passe ou le courriel n\'existe pas';
        setErrors(errorsForm);
      } else {
        user = {
          id: res.id,
          name: res.name,
          email: res.email,
          is_admin: res.is_admin,
          refreshValid: res.refreshValid,
        };
        setConnUser(user);
        localStorage.setItem('accessToken', res.access_token);
        localStorage.setItem('connUser', JSON.stringify(user));
        localStorage.setItem('admin', res.is_admin);
        localStorage.setItem('id', res.id);
        localStorage.setItem('name', res.name);

        if (!user.refreshValid) {
          onedrive(user.id);
        } else {
          navigate('/');
        }
      }
    }
  }

  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <LoginView
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        handleSubmit={handleSubmit}
        errors={errors} />
    </React.Fragment>
  );
}

export default Login;
